import { library } from '@fortawesome/fontawesome-svg-core'

import { faPlusCircle, faRemoveFormat, faSignInAlt, faSignOutAlt,faUser, faSpinner } from '@fortawesome/free-solid-svg-icons'

library.add( faPlusCircle, faRemoveFormat, faSignInAlt, faSignOutAlt,faUser, faSpinner)